import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/button/Button";
import SelectInput from "../../../../components/inputs/selectInput/SelectInput";
import TextInput from "../../../../components/inputs/textInput/TextInput";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import {
  createAppVersion,
  fetchLatestAppVersion,
} from "../../../../features/appVersion/appVersionSlice";
import styles from "./controlAppVersion.module.css";

const ControlAppVersion = () => {
  const dispatch = useDispatch();

  const [platform, setPlatform] = useState("");
  const [latestVersion, setLatestVersion] = useState("");
  const [minSupportedVersion, setMinSupportedVersion] = useState("");
  const [forceUpdate, setForceUpdate] = useState("false");
  const [redirectURL, setRedirectURL] = useState("");

  const { android, ios, createStatus, createError } = useSelector(
    (state) => state.appVersion
  );

  useEffect(() => {
    dispatch(fetchLatestAppVersion("android"));
    dispatch(fetchLatestAppVersion("ios"));
  }, [dispatch]);

  const handleAddVersion = () => {
    if (
      platform &&
      latestVersion.trim() !== "" &&
      minSupportedVersion.trim() !== "" &&
      redirectURL.trim() !== ""
    ) {
      dispatch(
        createAppVersion({
          platform,
          latestVersion,
          minSupportedVersion,
          forceUpdate: forceUpdate === "true",
          redirectURL,
        })
      );
    }
  };

  return (
    <SettingsPagesContainer
      title={"التحكم في الاصدار"}
      fullHeight
      displayContainerClassName={styles.displayContainer}
    >
      <div className={styles.summaryGrid}>
        <div className={styles.summaryCard}>
          <TextWrapper textStyle={"textXSmall"}>Android</TextWrapper>
          <TextWrapper textStyle={"textMid"}>
            {android.version || "لا يوجد إصدار"}
          </TextWrapper>
        </div>
        <div className={styles.summaryCard}>
          <TextWrapper textStyle={"textXSmall"}>iOS</TextWrapper>
          <TextWrapper textStyle={"textMid"}>
            {ios.version || "لا يوجد إصدار"}
          </TextWrapper>
        </div>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.fieldGroup}>
          <TextWrapper textStyle="textSmall">المنصة</TextWrapper>
          <SelectInput
            placeHolder={"اختيار المنصة"}
            setValue={setPlatform}
            value={platform}
            wrapperClassName={styles.fullWidthField}
            className={styles.fullWidthSelectButton}
          >
            <option value={"android"}>Android</option>
            <option value={"ios"}>iOS</option>
          </SelectInput>
        </div>
        <div className={styles.fieldGroup}>
          <TextWrapper textStyle="textSmall">أحدث إصدار</TextWrapper>
          <TextInput
            height="52px"
            width="100%"
            borderRadius="12px"
            placeHolder="Latest Version"
            bgColor={"grey"}
            bordered
            value={latestVersion}
            onChange={(e) => setLatestVersion(e.target.value)}
          />
        </div>
        <div className={styles.fieldGroup}>
          <TextWrapper textStyle="textSmall">أقل إصدار مدعوم</TextWrapper>
          <TextInput
            height="52px"
            width="100%"
            borderRadius="12px"
            placeHolder="Min Supported Version"
            bgColor={"grey"}
            bordered
            value={minSupportedVersion}
            onChange={(e) => setMinSupportedVersion(e.target.value)}
          />
        </div>
        <div className={styles.fieldGroup}>
          <TextWrapper textStyle="textSmall">تحديث إجباري</TextWrapper>
          <SelectInput
            placeHolder={"Force Update"}
            setValue={setForceUpdate}
            value={forceUpdate}
            wrapperClassName={styles.fullWidthField}
            className={styles.fullWidthSelectButton}
          >
            <option value={"true"}>True</option>
            <option value={"false"}>False</option>
          </SelectInput>
        </div>
        <div className={styles.fieldGroup}>
          <TextWrapper textStyle="textSmall">رابط التحويل</TextWrapper>
          <TextInput
            height="52px"
            width="100%"
            borderRadius="12px"
            placeHolder="Redirect URL"
            bgColor={"grey"}
            bordered
            value={redirectURL}
            onChange={(e) => setRedirectURL(e.target.value)}
          />
        </div>
      </div>
      {createError && (
        <div className={styles.errorState}>
          <TextWrapper textStyle="textSmall">{createError}</TextWrapper>
        </div>
      )}
      <div className={styles.addVersionWrapper}>
        {createStatus === "loading" ? (
          <div className={styles.loaderContainer}>
            <Loader />
          </div>
        ) : (
          <Button
            size="bigSize"
            variant="surfaceVariant"
            functionallity={handleAddVersion}
          >
            <TextWrapper textStyle="textMid">Add version</TextWrapper>
          </Button>
        )}
      </div>
    </SettingsPagesContainer>
  );
};

export default ControlAppVersion;
